import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {Subscription} from "../../../contracts/nexar-api/types";
import {APP_BASE_PATHNAMES} from "../../../core/consts/consts";

const KEY = "mynexar_pending_subs";
function getAutomaticallyOpenedSubscription(): string | null {
  return window.localStorage?.getItem(KEY);
}
function setAutomaticallyOpenedSubscription(subscriptionId: string) {
  return window.localStorage?.setItem(KEY, subscriptionId);
}

function getTheLastSubscription(subscriptions: Subscription[]): Subscription {
  function comparator(a: Subscription, b: Subscription) {
    const aTime = a.createdAt?.getTime();
    const bTime = b.createdAt?.getTime();
    if (aTime && bTime) {
      return bTime - aTime; // return the bigger one
    } else {
      if (aTime) {
        return -1; // return a first
      } else if (bTime) {
        return 1; // return b first
      } else {
        return 0;
      }
    }
  }
  return subscriptions.sort(comparator)[0];
}

export default function useAutomaticallyOpenPendingSubscription(
  subscriptions: Subscription[] | null
) {
  const navigate = useNavigate();
  // When connect is opened, if the last subscription is pending
  // we open it by default.
  useEffect(() => {
    if (subscriptions && subscriptions.length > 0) {
      if (!getAutomaticallyOpenedSubscription()) {
        const lastSubscripton = getTheLastSubscription(subscriptions);
        if (lastSubscripton.status === "PENDING") {
          setAutomaticallyOpenedSubscription(lastSubscripton.subscriptionId);
          navigate(
            `/${APP_BASE_PATHNAMES.CONNECT}/${APP_BASE_PATHNAMES.SUBSCRIPTIONS}/${lastSubscripton.subscriptionId}`
          );
        }
      }
    }
  }, [subscriptions]);
}
